import { Button } from "@mui/material";
import PropTypes from "prop-types";

export default function LogOutButton({ children = null, sx = {}, ...rest }) {
  LogOutButton.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
  };

  const requestToLogout = () => {
    window.location.href = "/logout/";
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      sx={{
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "grey.600",
          borderColor: "grey.600",
        },
        ...sx,
      }}
      {...rest}
      onClick={requestToLogout}
    >
      {children ?? "Log out"}
    </Button>
  );
}
